import React from 'react';
import { Input as AntInput } from 'antd';
import styled from 'styled-components';

const { TextArea } = AntInput;

const ExtendedTextarea = styled(TextArea)`
  &.ant-input {
    line-height: var(--font-line-height-regular);
    resize: none;

    &.white-background {
      background-color: var(--greyscale-white);
    }

    &.ai-generated-unedited {
      background-color: var(--ai-rose);
      border-color: var(--ai-grape);
    }
  }

  &.ant-input-disabled {
    background-color: var(--greyscale-porcelain);
    border: 1px solid var(--greyscale-dark-white);
    color: var(--greyscale-concrete) !important;
    cursor: default;

    &:hover {
      border: 1px solid var(--greyscale-dark-white);
    }
  }
`;

export const Textarea = (props) => <ExtendedTextarea {...props} maxLength={props.maxLength || 10000} />;
